import React, {useState, useEffect} from 'react';
import Style from './BaseLayout.module.scss'
import Navbar from "./Navbar";
import Home from "./home/Home";
import About from "./about/About";
import Podcast from "./podcast/Podcast";
import Livro from "./livro/Livro";
import SessaoAutocuidadoRedirect from "./SessaoAutocuidadoRedirect";
import {Route, Routes, useLocation} from "react-router-dom";
import {Box, Grid} from "@mui/material";
import {trackPageView} from "../analytics";

export default function BaseLayout() {
   let [darkMode, setDarkMode] = useState(false);
   const location = useLocation();

   useEffect(() => {
      // Track page view whenever route changes
      const pageNames = {
         '/': 'Home',
         '/about': 'Services/About',
         '/podcast': 'Podcast',
         '/livro': 'Book/Livro'
      };
      
      const pageName = pageNames[location.pathname] || 'Unknown';
      trackPageView(pageName, location.pathname);
   }, [location]);

   function handleClick() {
      setDarkMode(!darkMode);
   }

   return (
      <Box className={darkMode ? Style.dark : Style.light}>
         <Grid container display={'flex'} flexDirection={'column'} minHeight={'100vh'}
               justifyContent={'space-between'}>
            <Grid item>
               <Navbar darkMode={darkMode} handleClick={handleClick}/>
            </Grid>
            <Grid item flexGrow={1}>
               <Routes>
                  <Route exact path={'/'} element={<Home/>}/>
                  <Route exact path={'/about'} element={<About darkMode={darkMode}/>}/>
                  <Route exact path={'/podcast'} element={<Podcast darkMode={darkMode}/>}/>
                  <Route exact path={'/livro'} element={<Livro darkMode={darkMode}/>}/>
                  <Route exact path={'/sessaoautocuidado-wapp'} element={<SessaoAutocuidadoRedirect/>}/>
               </Routes>
            </Grid>
            {/* <Grid item>
               <Box component={'footer'} display={'flex'} flexDirection={'column'} alignItems={'center'}
                    py={'1.5rem'} sx={{opacity: 0.7}} width={'100%'}>
                  <p>template created with &hearts; by <a href={'https://paytonpierce.dev'}>Payton Pierce</a></p>
                  <p>&copy; 2022</p>
               </Box>
            </Grid> */}
         </Grid>
      </Box>
   )
}

